import React, { useState } from "react";
import ResponsiveNavbar from "./ResponsiveNavbar";
import ResponsiveFooter from "./ResponsiveFooter";
import EnquiryModal from "./EnquiryModal";
import EnquiryMobile from "./EnquireMobile";
import { useInView } from "../hooks/useInView";
const FOOTER_HEIGHT = "550px"; // Adjust this value to match your footer height  
interface LayoutProps {
  children: React.ReactNode;
}

/**
 * The magic:
 *  1.  <main> gets bottom-padding == footer height
 *  2.  A spacer div of identical height extends the scroll range
 *  3.  <DesktopFooter> is fixed to the bottom behind the content
 */
const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileModalOpen, setIsMobileModalOpen] = useState(false);

  // Sentinel for footer in-view detection
  const [footerSentinelRef, footerInView] = useInView<HTMLDivElement>({ threshold: 0.2 });

  return (
    <div className="min-h-screen flex flex-col">
      <ResponsiveNavbar onOpenEnquireModal={() => setIsModalOpen(true)}  onOpenMobileEnquireModal={() => setIsMobileModalOpen(true)} />

      {/* CONTENT — scrolls above the footer */}
      <main
       className={`
          relative z-0 flex-1
          sm:z-10 sm:pb-[${FOOTER_HEIGHT}px]   /* bottom padding only on ≥ 640 px */
        `}
      >
        {children}
      </main>

      {/* Invisible spacer = footer height */}
      <div className={`hidden sm:block`} style={{ height: FOOTER_HEIGHT }} aria-hidden />

      {/* Sentinel for footer in-view detection */}
      <div ref={footerSentinelRef} style={{ height: 1 }} />

      {/* Footer revealed on the very last scroll tick */}
      <ResponsiveFooter 
        onOpenEnquireModal={() => setIsModalOpen(true)}
        onOpenMobileEnquireModal={() => setIsMobileModalOpen(true)}
        footerInView={footerInView}
      />

      {/* Enquiry Modal */}
      <EnquiryModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <EnquiryMobile  open={isMobileModalOpen} onClose={() => setIsMobileModalOpen(false)} />
    </div>
  );
};

export default Layout;
